import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFormSwiftLogoHasBeenClicked } from 'StaticBuilder/StaticBuilderActions';

class HeaderIcon extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick();
    }
    this.props.setFormSwiftLogoHasBeenClicked();
  }

  render() {
    const iconClassName = window.COOKIE.get('userid') ? 'formswift-logo-link' : '';
    let iconHref = window.COOKIE.get('userid') ? '/my-documents' : '/';
    iconHref = this.props.onClick ? '#' : iconHref;

    return (
      <a href={iconHref} onClick={this.onClick} className={iconClassName}>
        <img
          src={`${window.cdnUrl}/images/logos/formswift-from-dropbox.png`}
          alt="FormSwift" className="formswift-dropbox-logo"
        />
        <img
          src={`${window.cdnUrl}/images/logos/formswift-from-dropbox-stacked.png`}
          alt="FormSwift" className="formswift-dropbox-logo-stacked"
        />
      </a>
    );
  }
}

HeaderIcon.defaultProps = {
  onClick: null,
};

HeaderIcon.propTypes = {
  onClick: PropTypes.func,
  setFormSwiftLogoHasBeenClicked: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    setFormSwiftLogoHasBeenClicked,
  }, dispatch)
);

export default ReactRedux.connect(
  null,
  mapDispatchToProps,
)(HeaderIcon);



// WEBPACK FOOTER //
// ./src-react/HeaderIcon/index.jsx